<!-- <div class="nav-pill">
     Page 4 &bull; Share Interview Link
</div> -->
<div class="share-link-container">
     <div class="share-link-header">
          <div class="share-link-icon">
               <mat-icon class="mat-icon-share">share</mat-icon>
          </div>
          <div>
               <div class="share-link-title">Share Interview Link</div>
               <div class="share-link-desc">Share this link to allow others to view the responses from this interview session</div>
          </div>
     </div>
     <div class="interview-link-label">Interview Link</div>
     <div class="interview-link-row compact-row">
          <input class="interview-link-input big-input" [value]="windowOrigin + '/chat/interview/' + templateId"
               readonly />
          <mat-icon class="mat-icon-copy" [class.animate-copied]="copied" (click)="copyLink()"
               matTooltip="{{ copied ? 'Copied!' : 'Copy link' }}">
               {{ copied ? 'check_circle' : 'content_copy' }}
          </mat-icon>
     </div>
     <div class="features-box compact-features">
          <div class="features-title mb-2 ">
               <mat-icon class="mat-icon-info">info</mat-icon>
               <span>Shared Link Features</span>
          </div>
          <ul class="features-list compact-list">
               <li>View-only access to interview responses</li>
               <li>User questions are hidden for privacy</li>
               <li>Real-time updates as interview progresses</li>
               <li>No login required for viewers</li>
          </ul>
     </div>
     <div class="details-box compact-details">
          <div class="details-title compact-title">Interview Details</div>
          <ng-container *ngIf="interviewDetails; else noDetails">
               <div class="details-grid compact-grid">
                    <div>
                         <p>Candidate:</p>
                    </div>
                    <div>{{ interviewDetails.consultantName }}</div>
                    <div>
                         <p>Role:</p>
                    </div>
                    <div>{{ interviewDetails.interviewingRole }}</div>
                    <div>
                         <p>Interview Code:</p>
                    </div>
                    <div>{{ templateId }}</div>
                    <div>
                         <p>Status:</p>
                    </div>
                    <div class="status-green">Ready to Start</div>
               </div>
          </ng-container>
          <ng-template #noDetails>
               <p>Interview details not found.</p>
               <p><strong>Interview Code:</strong> {{ templateId }}</p>
          </ng-template>
     </div>
     <button class="continue-btn" (click)="continueToInterview()">
          Continue to Interview
     </button>
     <!-- <div class="features-box" style="background:#e0e7ff;color:#222;">
          <strong>Privacy Note:</strong> Only interview responses will be visible to viewers. Questions and personal information remain private.
     </div> -->
     <!-- <p style="color:#6b6b6b;font-size:0.95rem;text-align:center;margin-top:8px;">
          After clicking ‘Start Interview,’ you can generate and share the interview link with others.
     </p> -->
</div>